import { lazy, Suspense } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ThirdPartyCallingRemote = /*#__PURE__*/lazy(() => import('./ThirdPartyCallingRemote'));
export const LazyThirdPartyCallingRemote = props => {
  const {
    userId,
    isLoading,
    ownerId
  } = props;
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(ThirdPartyCallingRemote, {
      isLoading: isLoading,
      userId: userId,
      ownerId: ownerId
    })
  });
};